import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectConsoleTypes } from 'msp/enums/project-console-types.enum';
import { channelSubTypeValues } from '../../../models/static-list-data.service';

@Component({
    selector: 'app-channel-subtype-lookup',
    templateUrl: './channel-subtype-lookup.component.html',
    styleUrls: ['./channel-subtype-lookup.component.css']
})
export class ChannelSubtypeLookupComponent implements OnInit {

    @Input() set resetData(isClear) {
        if (isClear) {
          this.channelSubtypeSelected = [];
        }
      }
      @Output() selectedChannelSubtype: EventEmitter<any> = new EventEmitter;
    
      channelSubtypeList = [];
      channelSubtypeSelected = [];
      isMultipleSelected = true;
      
      constructor() { }
    
      ngOnInit() {
        this.channelSubtypeList = channelSubTypeValues;
        const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
        this.channelSubtypeSelected = (preselected &&
          preselected['channelSubtype']) ? preselected['channelSubtype'] : '';
      }
    
      onchannelSubtypeChange() {
        this.selectedChannelSubtype.emit(this.channelSubtypeSelected);
      }
      
      clearChannelSubtype() {
        this.channelSubtypeSelected = [];
        this.selectedChannelSubtype.emit([]);
      }

}
